module.exports = __webpack_public_path__ + "img/tu-5.996d892c.png";